/**
 * Generated by scripts/build-emote-packs.mjs from the packs in public/emotes/.
 * Do not edit: run `npm run build:emote-packs` instead.
 *
 * These are imported artwork drawn as <img>, not rows of the sprite sheet - the
 * files keep their own size and their own animation. Only English shortcodes:
 * they are the names their authors gave them, not words to translate.
 */
export const PACK_EMOTES = [
  { codes: { en: 'pepesmoke' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/1223_PepeSmoke.gif', width: 250, height: 250 },
  { codes: { en: 'pixelcri' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/1352-pixelcri.gif', width: 112, height: 112 },
  { codes: { en: 'pepechristmashype' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/2076_pepechristmashype.gif', width: 65, height: 65 },
  { codes: { en: 'pepetriggered' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/2348-pepetriggered.gif', width: 40, height: 40 },
  { codes: { en: 'bunnypeped' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/2533-bunnypeped.gif', width: 112, height: 112 },
  { codes: { en: 'piratepeped' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/3307-piratepeped.gif', width: 112, height: 112 },
  { codes: { en: 'typingpeped' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/4014-typingpeped.gif', width: 112, height: 112 },
  { codes: { en: 'sweat' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/4159-sweat.gif', width: 63, height: 63 },
  { codes: { en: 'pixelpepe' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/4460_PixelPepe.gif', width: 112, height: 112 },
  { codes: { en: 'pepesonbed' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/4875-pepes-on-bed.gif', width: 112, height: 112 },
  { codes: { en: 'stare' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/4934-stare.gif', width: 112, height: 112 },
  { codes: { en: 'maracaspeped' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/5261-maracaspeped.gif', width: 112, height: 112 },
  { codes: { en: 'sombreopeped' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/5261-sombreopeped.gif', width: 112, height: 112 },
  { codes: { en: 'whiteflagpeped' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/5461-whiteflagpeped.gif', width: 112, height: 112 },
  { codes: { en: 'riotpeped' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/6028-riotpeped.gif', width: 112, height: 112 },
  { codes: { en: 'pepecowboy' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/6424-pepecowboy.gif', width: 112, height: 112 },
  { codes: { en: 'rollpeped' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/6731-rollpeped.gif', width: 112, height: 112 },
  { codes: { en: 'ppoverheat' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/6772-ppoverheat.gif', width: 44, height: 44 },
  { codes: { en: 'skatepeped' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/8600-skatepeped.gif', width: 112, height: 112 },
  { codes: { en: 'peperun' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/8733_Peperun.gif', width: 72, height: 72 },
  { codes: { en: 'popcornpeped' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/8988-popcornpeped.gif', width: 112, height: 112 },
  { codes: { en: 'pepeexcited' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/9101-pepe-excited.gif', width: 112, height: 112 },
  { codes: { en: 'pppoof' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/9591_ppPoof.gif', width: 112, height: 112 },
  { codes: { en: 'appjedi' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/9756_AppJedi.gif', width: 72, height: 72 },
  { codes: { en: 'pixelhonkler' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/9934_Pixel_Honkler.png', width: 121, height: 128 },
  { codes: { en: 'pixelpepefedora' }, pack: 'pixel-pepes',
    src: '/emotes/pixel-pepes/PixelPepeFedora.gif', width: 112, height: 112 },
];

export default { PACK_EMOTES };
